export default {
    props: ['is-loading', 'pagination'],
    computed: {
        hasNextPage: function() {
            if ( this.pagination.links ) {
                return this.pagination.links.next !== undefined;
            }
            return false;
        }
    },
    methods: {
        onClick: function() {
            this.$emit('loadMore');
        }
    },
    template: `
        <button
            class="load_more"
            :disabled="isLoading"
            v-show="hasNextPage"
            @click="onClick">Load More</button>
    `
};
